import { fetchSchoolHolidays } from "./vacances";
// Fonction qui vérifie les doublons de titre dans filteredSequences
export const verifTitreSeq = (newEvent, filteredSequences) => {
        
    // On initialise un tableau qui contiendra les messages d'erreur
            const errors = [];
            // Vérifier que newEvent et son titre existent
    if (!newEvent || !newEvent.title) {
        errors.push({ message: "Le titre de l'événement est manquant." });
        return errors;
    }
    
    // On parcourt les séquences déjà présentes

    filteredSequences.forEach(seq => {
    if (seq.title.trim().toLowerCase() === newEvent.title.trim().toLowerCase() && seq.type==="SEQUENCE") {
        errors.push({
        title: seq.title,
        start: seq.start,
        end: seq.end,
        message: `Une séquence avec le titre "${seq.title}" existe déjà (du ${new Date(seq.start).toLocaleDateString('fr-FR')} au ${new Date(seq.end).toLocaleDateString('fr-FR')}).`
        });
    }
    });
    return errors;
};



// Fonction qui calcule et retourne la plage de dates basée sur l'année scolaire
export const getSlidingYearRange = async () => {
  try {
    // Récupérer les données des vacances scolaires et périodes
    const { periode } = await fetchSchoolHolidays();
    
    if (!periode || periode.length === 0) {
      // Fallback en cas d'urgence : utiliser l'année civile
      return getFallbackYearRange();
    }

    // Utiliser la première date_debut et la dernière date_fin des périodes
    const minDate = periode[0].date_debut;
    const maxDate = periode[periode.length - 1].date_fin;

    return { min: minDate, max: maxDate };

  } catch (error) {
    console.error("Erreur lors du calcul de la plage scolaire :", error);
    // Fallback en cas d'erreur
    return getFallbackYearRange();
  }
};


// Fonction de fallback en cas d'urgence
const getFallbackYearRange = () => {
  const currentYear = new Date().getFullYear();
  const minYear = currentYear - 1;
  const maxYear = currentYear + 1;
  
  return {
    min: `${minYear}-01-01`,
    max: `${maxYear}-12-31`
  };
};